import * as React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {GameStripeImageComponent} from './stripe-image/game-stripe-image.component';
import {GameTrailerComponent} from './trailer/game-trailer.component';
import {observer} from 'mobx-react';
import {GameInfo} from '../../../../services/games/game-info';

export interface GameImageContainerComponentProps {
    gameInfo: GameInfo;
}

export const TrailerOrStripeImageComponent = observer(
    class TrailerOrStripeImageComponent extends OrbitComponent<GameImageContainerComponentProps> {
        render() {
            if (this.props.gameInfo.hasVideoTrailer) {
                return (
                    <GameTrailerComponent gameInfo={this.props.gameInfo}/>
                );
            } else {
                return (
                    <GameStripeImageComponent gameInfo={this.props.gameInfo}/>
                );
            }
        }
    }
);
